module.exports = __webpack_public_path__ + "img/join_store.d68200e8.svg";